import * as common from './validation-common';
import * as core from './validation-core';
import * as domain from './validation-domain';

export const Validators = {
    // core functions that allow to create opionaled redux-form ready validation functions
    ...core,

    // common unopionated validators
    ...common,

    // cloud specific validators
    ...domain,
};

export * from './validation-utils';
